import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import imgSOE from "./Assets/newsroom/soeawards.png";
import imgStraits from "./Assets/newsroom/straitstime.png";
import imgHerWorld from "./Assets/newsroom/herworld.png";
import imgWomenWeekly from "./Assets/newsroom/womanweekly.png";
import imgDanamic from "./Assets/newsroom/danamic.png";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handle);
    return () => window.removeEventListener("resize", handle);
  }, []);
  return isMobile;
};

const articles = [
  {
    id: 1,
    image: imgSOE,
    sourceKey: "newsroom.articles.soe.source",
    dateKey: "newsroom.articles.soe.date",
    summaryKey: "newsroom.articles.soe.summary",
    showButton: false,
  },
  {
    id: 2,
    image: imgStraits,
    sourceKey: "newsroom.articles.straits.source",
    dateKey: "newsroom.articles.straits.date",
    summaryKey: "newsroom.articles.straits.summary",
    showButton: false,
  },
  {
    id: 3,
    image: imgHerWorld,
    sourceKey: "newsroom.articles.herWorld.source",
    dateKey: "newsroom.articles.herWorld.date",
    summaryKey: "newsroom.articles.herWorld.summary",
    showButton: false,
  },
  {
    id: 4,
    image: imgWomenWeekly,
    sourceKey: "newsroom.articles.womensWeekly.source",
    dateKey: "newsroom.articles.womensWeekly.date",
    summaryKey: "newsroom.articles.womensWeekly.summary",
    link: "https://www.womensweekly.com.sg/shopping/improve-fengshui-and-increase-success-with-these-jewellery-pieces",
  },
  {
    id: 5,
    image: imgDanamic,
    sourceKey: "newsroom.articles.danamic.source",
    dateKey: "newsroom.articles.danamic.date",
    summaryKey: "newsroom.articles.danamic.summary",
    link: "https://danamic.org/2019/05/05/gifts-less-ordinary-matrix-fengshui-blessings-with-master-siewli/",
  },
];

const Newsroom = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [featured, ...rest] = articles;

  return (
    <div style={pageWrapperStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <p style={eyebrowStyle}>Hé by SiewLi</p>
        <h1 style={{ ...titleStyle, fontSize: isMobile ? "2.2rem" : "3rem" }}>
          {t("footer.newsroom")}
        </h1>
        <p style={subtitleStyle}>
          {t("newsroom.subtitle")}
        </p>
        <hr style={dividerStyle} />
      </div>

      <div style={{ maxWidth: "1100px", margin: "0 auto", width: "100%", padding: isMobile ? "0 16px" : "0 48px", boxSizing: "border-box" }}>

        {/* ── Featured card ── */}
        <div
          style={{
            ...heroCardStyle,
            flexDirection: isMobile ? "column" : "row",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "rgba(223,189,105,0.6)";
            e.currentTarget.style.boxShadow = "0 16px 48px rgba(0,0,0,0.5)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "rgba(223,189,105,0.25)";
            e.currentTarget.style.boxShadow = "0 4px 24px rgba(0,0,0,0.3)";
          }}
        >
          {/* Image side */}
          <div style={{ ...heroImageWrapperStyle, height: isMobile ? "240px" : "100%" }}>
            <div style={{ ...blurBackdropStyle, backgroundImage: `url(${featured.image})` }} />
            <img src={featured.image} alt={t(featured.sourceKey)} style={heroImgStyle} />
          </div>

          {/* Content side */}
          <div style={heroContentStyle}>
            <span style={featuredTagStyle}>{t("newsroom.featured")}</span>
            <div style={cardMetaStyle}>
              <span style={categoryBadgeStyle}>{t(featured.sourceKey)}</span>
              <span style={dateStyle}>{t(featured.dateKey)}</span>
            </div>
            <h2 style={heroTitleStyle}>{t(featured.summaryKey)}</h2>
            {featured.showButton !== false && (
              <button
                style={heroButtonStyle}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#deaf77"; e.currentTarget.style.color = "#0a031e"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = "#deaf77"; }}
              >
                {t("newsroom.readMore")}
              </button>
            )}
          </div>
        </div>

        {/* ── Grid cards (masonry) ── */}
        <div style={{
          columns: isMobile ? 1 : 2,
          columnGap: "20px",
          marginTop: "20px",
          paddingBottom: "64px",
        }}>
          {rest.map((article) => (
            <div
              key={article.id}
              style={{
                ...cardStyle,
                breakInside: "avoid",
                marginBottom: "20px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "rgba(223,189,105,0.6)";
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "rgba(223,189,105,0.2)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div style={cardImageWrapperStyle}>
                <img src={article.image} alt={t(article.sourceKey)} style={cardImageStyle} />
              </div>
              <div style={cardBodyStyle}>
                <div style={cardMetaStyle}>
                  <span style={categoryBadgeStyle}>{t(article.sourceKey)}</span>
                  <span style={dateStyle}>{t(article.dateKey)}</span>
                </div>
                <p style={cardSummaryStyle}>{t(article.summaryKey)}</p>
                {article.showButton !== false && (
                  <button
                    style={readMoreStyle}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(223,189,105,0.12)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
                    onClick={() => article.link && window.open(article.link, "_blank", "noopener,noreferrer")}
                  >
                    {t("newsroom.readMore")}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer note */}
      {/* <p style={footerNoteStyle}>
        For press inquiries, please contact{" "}
        <a href="mailto:contact@xianhefairy.com" style={linkStyle}>
          contact@xianhefairy.com
        </a>
      </p> */}
    </div>
  );
};

const pageWrapperStyle = {
  minHeight: "100vh",
  background: "transparent",
  display: "flex",
  flexDirection: "column",
  fontFamily: "DMSans, 'DM Sans', 'Segoe UI', sans-serif",
};

const headerStyle = {
  textAlign: "center",
  padding: "60px 24px 36px",
};

const eyebrowStyle = {
  color: "#deaf77",
  fontSize: "11px",
  letterSpacing: "0.2em",
  fontWeight: "bold",
  margin: "0 0 10px",
  opacity: 0.8,
};

const titleStyle = {
  color: "#deaf77",
  fontFamily: "'Playfair Display', Georgia, serif",
  fontWeight: 800,
  margin: "0 0 10px",
};

const subtitleStyle = {
  color: "rgba(255,255,255,0.5)",
  fontSize: "15px",
  margin: "0 auto 24px",
};

const dividerStyle = {
  border: "none",
  borderTop: "1px solid rgba(223,189,105,0.25)",
  width: "50%",
  margin: "0 auto",
};

/* ── Hero card ── */
const heroCardStyle = {
  display: "flex",
  borderRadius: "16px",
  overflow: "hidden",
  border: "1px solid rgba(223,189,105,0.25)",
  backgroundColor: "rgba(255,255,255,0.03)",
  boxShadow: "0 4px 24px rgba(0,0,0,0.3)",
  transition: "border-color 0.25s ease, box-shadow 0.25s ease",
  cursor: "pointer",
  minHeight: "320px",
  marginBottom: "0",
};

const heroImageWrapperStyle = {
  position: "relative",
  flex: "0 0 48%",
  overflow: "hidden",
  backgroundColor: "#0a031e",
};

const heroImgStyle = {
  position: "relative",
  display: "block",
  width: "100%",
  height: "100%",
  objectFit: "contain",
  zIndex: 1,
};

const heroContentStyle = {
  flex: 1,
  padding: "36px 32px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "14px",
  borderLeft: "1px solid rgba(223,189,105,0.15)",
};

const featuredTagStyle = {
  color: "#deaf77",
  fontSize: "10px",
  letterSpacing: "0.2em",
  fontWeight: "bold",
  opacity: 0.7,
};

const heroTitleStyle = {
  color: "#ffffff",
  fontSize: "22px",
  fontFamily: "'Playfair Display', Georgia, serif",
  fontWeight: 700,
  lineHeight: "1.45",
  margin: 0,
};

const heroButtonStyle = {
  alignSelf: "flex-start",
  background: "transparent",
  border: "1px solid #deaf77",
  color: "#deaf77",
  borderRadius: "30px",
  padding: "10px 28px",
  fontSize: "13px",
  cursor: "pointer",
  transition: "background-color 0.2s ease, color 0.2s ease",
  marginTop: "4px",
};

/* ── Grid cards ── */
const cardStyle = {
  backgroundColor: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(223,189,105,0.2)",
  borderRadius: "14px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  transition: "border-color 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease",
  cursor: "pointer",
};

const cardImageWrapperStyle = {
  width: "100%",
  overflow: "hidden",
  borderBottom: "1px solid rgba(223,189,105,0.1)",
};

const blurBackdropStyle = {
  position: "absolute",
  inset: 0,
  backgroundSize: "cover",
  backgroundPosition: "center",
  filter: "blur(18px) brightness(0.4) saturate(1.2)",
  transform: "scale(1.1)",
};

const cardImageStyle = {
  display: "block",
  width: "100%",
  height: "auto",
};

const cardBodyStyle = {
  padding: "18px 20px 22px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const cardMetaStyle = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "10px",
};

const categoryBadgeStyle = {
  backgroundColor: "rgba(223,189,105,0.12)",
  color: "#deaf77",
  fontSize: "10px",
  fontWeight: "bold",
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  padding: "3px 10px",
  borderRadius: "20px",
  border: "1px solid rgba(223,189,105,0.3)",
};

const dateStyle = {
  color: "rgba(255,255,255,0.35)",
  fontSize: "12px",
};

const cardSummaryStyle = {
  color: "rgba(255,255,255,0.75)",
  fontSize: "15px",
  lineHeight: "1.6",
  margin: 0,
  flex: 1,
};

const readMoreStyle = {
  alignSelf: "flex-start",
  background: "transparent",
  border: "1px solid rgba(223,189,105,0.45)",
  color: "#deaf77",
  borderRadius: "6px",
  padding: "6px 18px",
  fontSize: "13px",
  cursor: "pointer",
  marginTop: "4px",
  transition: "background-color 0.2s ease",
};

const footerNoteStyle = {
  textAlign: "center",
  color: "rgba(255,255,255,0.3)",
  fontSize: "13px",
  padding: "8px 24px 52px",
};

const linkStyle = {
  color: "#deaf77",
  textDecoration: "none",
};

export default Newsroom;
